<template>
  <BaseEntityBadge
    v-if="column.cellType === 'entity'"
    :initials="cellValue.initials"
    :name="cellValue.name"
    :meta="cellValue.meta"
  />
  <BaseStatusPill
    v-else-if="column.cellType === 'status'"
    :label="cellValue.label"
    :variant="cellValue.variant"
  />
  <BaseStatusProgress
    v-else-if="column.cellType === 'progress'"
    v-bind="cellValue"
    dense
  />
  <span
    v-else-if="column.cellType === 'detail_drawer' && row[column.key]"
    class="dashboard-table-cell__detail"
    @click="$emit('detail', row)"
  >
    →
  </span>
  <span v-else>
    <slot>
      {{ row[column.key] }}
    </slot>
  </span>
</template>

<script>
import BaseEntityBadge from './BaseEntityBadge.vue'
import BaseStatusPill from './BaseStatusPill.vue'
import BaseStatusProgress from './BaseStatusProgress.vue'

export default {
  name: 'BaseDashboardTableCell',
  components: { BaseEntityBadge, BaseStatusPill, BaseStatusProgress },
  props: {
    column: {
      type: Object,
      required: true
    },
    row: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    cellValue() {
      return this.row[this.column.key] || {}
    }
  }
}
</script>

<style lang="scss">
.dashboard-table-cell {
  &__detail {
    color: var(--ds-color-black-040);
    cursor: pointer;

    &:hover {
      color: var(--ds-color-black-055);
    }
  }
}
</style>
